import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import { FontWeight, QuicksandBold } from "components/Text";

export const Content = styled.div`
  background: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 10px 0px;
  background: ${Colors.WHITE};
  ${({ noPadding }) =>
    noPadding
      ? ""
      : `
    padding: 10px 10px 10px 10px;
  `}
  border-radius: 0px 0px 20px 20px;
  ${({ noBorderRadius }) => noBorderRadius ? '' : `border-radius: 0px 0px 20px 20px;`}
  ${({ noBorder, colorBorder }) => noBorder ? '' : `border: 1px solid ${colorBorder || Colors.SECONDARY};`}
  ${({ customShadow }) => customShadow || `box-shadow: 0px 17px 17px 6px ${Colors.GRAY[4]};`}
  ${({ mr }) => mr ? `margin-right: ${mr}px` : ''}
`;

export const Heading = styled.div`
  ${({ color }) => `background: ${color}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px 15px;
  font-size: 18px;
  border-radius: 8px 8px 0px 0px;
  margin-top: 20px;
  height: 50px;

  color: ${Colors.WHITE};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  ${({ mr }) => mr ? `margin-right: ${mr}px` : ''}
  ${({ mt }) => mt ? `margin-top: ${mt}px` : ''}
`;

export const RightButton = styled.span`
  font-size: 18px;
  color: ${Colors.SECONDARY1};
  cursor:pointer;
`;